$(document).ready(function() {
  var $slider = $('.client_slider');
  var $progressBar = $('.progress_outer .progress_bar');
  var $progressBarLabel = $('.progress_outer .slider__label');

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
    
    $progressBar.find('.progress_bar_complete')
      .css('width', calc + '%')
      .attr('aria-valuenow', calc);
    
    $progressBarLabel.text(calc.toFixed(0) + '% completed');
  });

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 400,
    prevArrow: $('.client_slick_prev'),
    nextArrow: $('.client_slick_next'),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});